import { useState } from "react";

import { BdsIconGiveFeedback, type TBdsButtonDisplayTypes } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTPopover } from "commonComponents/btWrappers/BTPopover/BTPopover";
import FeedbackWidget from "commonComponents/feedback/FeedbackWidget/FeedbackWidget";

import { type FeedbackTarget } from "handlers";

interface IFeedbackEmbeddableIconProps {
    feedbackTarget: FeedbackTarget;
    ratingMode?: "hidden" | "optional" | "required";
    className?: string;
    extraInfo?: string;
    feedbackText?: string;
    buttonText?: string;
    showIcon?: boolean;
    displayType?: TBdsButtonDisplayTypes;
    tooltip?: string;
}

function FeedbackEmbeddableIcon(props: IFeedbackEmbeddableIconProps) {
    const {
        feedbackTarget,
        ratingMode = "optional",
        className = "",
        extraInfo,
        feedbackText,
        buttonText,
        showIcon = true,
        displayType = "tertiary",
        tooltip,
    } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const icon = showIcon ? <BdsIconGiveFeedback /> : undefined;
    const button = (
        <BTButton
            className={`FeedbackEmbeddableIcon ${className}`}
            onClick={() => setIsModalOpen(true)}
            data-testid="feedback-embeddable-icon-button"
            aria-label="Give feedback"
            icon={icon}
            type={displayType}
        >
            {buttonText}
        </BTButton>
    );
    return (
        <>
            {tooltip ? (
                <BTPopover content={tooltip} placement="top">
                    {button}
                </BTPopover>
            ) : (
                button
            )}

            {isModalOpen && (
                <FeedbackWidget
                    feedbackTarget={feedbackTarget}
                    ratingMode={ratingMode}
                    onClose={() => setIsModalOpen(false)}
                    onSubmitSuccess={() => setIsModalOpen(false)}
                    extraInfo={extraInfo}
                    feedbackText={feedbackText}
                />
            )}
        </>
    );
}

export default FeedbackEmbeddableIcon;
